// Helper functions
const createScript = text => {
  const script = document.createElement("script")
  script.type = "text/javascript"
  script.text = text
  return script
}

const removeElement = selector => {
  const element = document.querySelector(selector)
  if (element) element.remove()
}

const cleanupWidget = () => {
  removeElement("#docsbotai-root")
  removeElement(".docsbotai-chat-button")
}

// Main initialization function
const initDocsBot = () => {
  if (typeof window === "undefined") return

  // Create and inject the DocsBot script with initialization
  const script = createScript(`
    window.DocsBotAI=window.DocsBotAI||{},DocsBotAI.init=function(e){return new Promise((t,r)=>{var n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://widget.docsbot.ai/chat.js";let o=document.getElementsByTagName("script")[0];o.parentNode.insertBefore(n,o),n.addEventListener("load",()=>{let n;Promise.all([new Promise((t,r)=>{window.DocsBotAI.mount(Object.assign({}, e)).then(t).catch(r)}),(n=function e(t){return new Promise(e=>{if(document.querySelector(t))return e(document.querySelector(t));let r=new MutationObserver(n=>{if(document.querySelector(t))return e(document.querySelector(t)),r.disconnect()});r.observe(document.body,{childList:!0,subtree:!0})})})("#docsbotai-root"),]).then(()=>t()).catch(r)}),n.addEventListener("error",e=>{r(e.message)})})};
    if (typeof window.DocsBotAI !== 'undefined' && typeof window.DocsBotAI.init === 'function') {
      window.DocsBotAI.init({id: "nLYZsPFrpGkRMIGAVYlh/bCJbnIlXIYr9u1Y7lh7d"});
    }
  `)
  document.body.appendChild(script)

  // Handle Gatsby navigation
  if (window.___navigate) {
    const originalNavigate = window.___navigate
    window.___navigate = function (to, options) {
      cleanupWidget()
      return originalNavigate(to, options)
    }
  }

  // Return cleanup function
  return () => {
    cleanupWidget()
    document.body.removeChild(script)
  }
}

export { initDocsBot }
